import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency } from "../SheetLayout";

const ComisionPrestacionesEspeciales: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const comisionPrestacionEspecialId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getSpecialBenefitsCommission, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getSpecialBenefitsCommission(userId, prestacionId, comisionPrestacionEspecialId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Comisión Prestaciones Especiales"
        icon="euro"
        pills={<>
          {d.codigo && <SheetPill label="Código" value={formatText(d.codigo)} />}
          <SheetPill label="Fecha solicitud" value={formatDate(d.fechaPresentacion)} icon="calendar" />
        </>}
      />

      <SheetSection title="Solicitud" icon="file-text">
        <SheetGrid>
          <SheetField label="Código"           value={formatText(d.codigo)} />
          <SheetField label="Fecha Solicitud"  value={formatDate(d.fechaPresentacion)} />
          <SheetField label="Tipo Solicitud"   value={formatText(d.tipoSolicitudSocial)} />
          <SheetField label="Importe Solicitud" value={formatCurrency(d.importeSolicitud)} />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Resolución" icon="check-circle">
        <SheetGrid>
          <SheetField label="Estado solicitud"       value={formatText(d.estadoSolicitud)} />
          <SheetField label="Fecha de Pago/Ingreso"  value={formatDate(d.fechaPago)} />
          <SheetField label="Cuantía Económica Neto" value={formatCurrency(d.cuantiaEconomicaNeto)} />
          <SheetField label="% de Retención"         value={formatText(d.retencion)} />
        </SheetGrid>
      </SheetSection>
    </SheetPage>
  );
};

export default ComisionPrestacionesEspeciales;
